module.exports = __webpack_public_path__ + "static/placeholder-lg-a6be94f6c460a84dfd85dd7774082a15.png";